import { Button, Form, Input, Popconfirm, JoditEditor } from "./../../ui/ot"
import { useRef, useState } from "react";

const PopconfirmForm = ({
    children,
    title = "",
    description = "",
    onConfirm = () => { },
    onCancel = () => { },
    record = {}
}) => {
    const editor = useRef(null);

    const [form] = Form.useForm();
    const [contact_content, set_contact_content] = useState("")
    const [popOpen, setPopOpen] = useState(false)
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: 'zh_tw',
        i18n: {
            zh_tw: {
                'Default': "預設",
                'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
                    'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.',
                Anchor: 'Anchor',
                Margins: '外邊距（Margins）',
                top: 'top',
                right: 'right',
                bottom: 'bottom',
                left: 'left',
                Classes: 'Classes',
                Src: 'Src',
                Title: 'Title',
                Link: 'Link',
                file: 'file',
                'Image properties': '圖片屬性',
                'Your code is similar to HTML. Keep as HTML?':
                    '你黏貼的文本是一段html代碼，是否保留源格式',
                'Paste as HTML': 'html黏貼',
                'Insert as Text': '把html代碼視為普通文本',
                'Error on load list': '加載list錯誤',
                Break: 'Pause',
                'No follow': 'No follow',
                'URL': 'URL',
                Crop: 'Crop',
                Default: '默認',
                Circle: '圓圈',
                Dot: '點',
                Quadrate: '方形',
                Find: '搜尋',
                'Insert className': '插入標籤名稱',
                'Press Alt for custom resizing': '按Alt自定義調整大小',
                'Find Next': '找下一個',
                'Find Previous': '找上一個',
                'replace': '替代',
                'Line height': '行高'
            }
        },
        uploader: {
            insertImageAsBase64URI: true,
            imagesExtensions: [
                "jpg",
                "png",
                "jpeg",
                "gif",
                "svg",
                "webp",
            ],
        },
    };
    return (<>
        <Form
            form={form}
        >
            <Popconfirm
                open={popOpen}
                placement={'left'}
                title={title}
                description={(<>
                    {(<>
                        <Form.Item
                            label={'客制標題'}
                            name="customize_title"
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={'客制訊息'}
                            name="customize_content"
                        >
                        </Form.Item>
                        <JoditEditor
                            ref={editor}
                            value={contact_content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={contact_content => set_contact_content(contact_content)} // preferred to use only this option to update the content for performance reasons
                            height={500}
                            allowResizeX={true}
                            allowResizeY={true}
                        />
                    </>)}
                    {description}
                </>)}
                onConfirm={() => { setPopOpen(false); onConfirm(form.getFieldsValue()) }}
                onCancel={() => { setPopOpen(false); onCancel() }}
            >
                <Button
                    type="link"
                    style={{
                        color: '#407586'
                    }}
                    onClick={() => setPopOpen(pre => !pre)}
                >
                    {children}
                </Button>
            </Popconfirm>
        </Form>
    </>)
}
export default PopconfirmForm